import propTypes from 'prop-types';
import { ErrorMessage, Label } from '@kiper/ui';
import { IMAGE_EXTENSIONS } from '../../../../utils/validateGeneratorForm';
import * as S from './styles';

const ACCEPTED_FILES = IMAGE_EXTENSIONS.map(extension => `.${extension}`).join(
  ',',
);

const FileField = ({ name, label, error, onChange }) => {
  const handleChange = event => onChange(name, event.target.files?.[0] || null);

  return (
    <S.Wrapper>
      <S.LabelRow>
        <Label htmlFor={name}>{label}</Label>
        <span>*</span>
      </S.LabelRow>
      <S.FileInput
        id={name}
        name={name}
        type="file"
        accept={ACCEPTED_FILES}
        onChange={handleChange}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </S.Wrapper>
  );
};

FileField.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  error: propTypes.string,
  onChange: propTypes.func.isRequired,
};

FileField.defaultProps = {
  error: '',
};

export default FileField;
